const jsonCloneDeep = obj => obj !== undefined ? JSON.parse(JSON.stringify(obj)) : null
export default jsonCloneDeep
